var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.86741 5.73806C5.10826 5.24169 4.39015 4.74532 3.65152 4.24896C2.5846 3.54443 1.51769 2.8239 0.4713 2.11938C0.204572 1.94325 0.0814665 1.70307 0.163536 1.43087C0.245606 1.15866 0.471299 0.982532 0.820096 0.902473C1.10734 0.838425 1.37407 0.902472 1.62028 1.06259C3.05651 2.0233 4.51325 2.98402 5.94948 3.96074C6.565 4.36104 7.18053 4.77735 7.77554 5.17764C8.28847 5.51389 8.26796 5.97824 7.77554 6.31449C5.72378 7.69151 3.67203 9.05252 1.62028 10.4295C1.20993 10.7017 0.65596 10.6857 0.32768 10.3815C-0.000600184 10.0773 0.0404349 9.64496 0.471303 9.37276C2.21529 8.20389 3.95928 7.05104 5.70327 5.88217C5.72378 5.85014 5.78534 5.80211 5.86741 5.73806Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowL);
export default __webpack_public_path__ + "static/media/arrow_l.da5f494ba092f075fbce336049c715b1.svg";
export { ForwardRef as ReactComponent };